import { getColorGroup, toHalfWidth } from '../../helper/utils';

// How the shared SavedSearches panel reads auction saved searches: { name, filter,
// search?, notifyEnabled, createdAt }, kept in the user's savedFilters.

// FilterAccordion ticks these alongside the make the user picked (BMW brings BMW ALPINA,
// and so on). They are part of the stored filter but not something the user chose.
const COMPANION_MAKERS = ['BMW ALPINA', 'NISSAN DIESEL', 'OVERSEAS NISSAN', 'MITSUBISHI FUSO'];

// filterString is the `&filter[key]=<json array>` chain FilterAccordion builds.
const parseFilterString = (filterString = '') => {
  const filters = {};
  filterString.split('&filter').forEach((part) => {
    const eq = part.indexOf('=');
    if (eq < 0) return;
    const key = part.slice(0, eq).replace('[', '').replace(']', '');
    try {
      const values = JSON.parse(part.slice(eq + 1));
      if (Array.isArray(values) && values.length > 0) filters[key] = values;
    } catch (e) {
      // A value we cannot read is left out, as the API does.
    }
  });
  return filters;
};

/** The search on screen, in saved-search shape. */
export const auctionCurrentSearch = (filterString, searchText) => {
  const text = (searchText || '').trim();
  return { filter: filterString || '', ...(text ? { search: text } : {}) };
};

export const auctionSavedSearchAdapter = {
  field: 'savedFilters',
  collapsedKey: 'auctionSavedSearchesCollapsed',
  carsLabel: 'auction cars',
  listingsLabel: 'auction listings',

  // Two searches are the same search when they pick the same values and the same
  // search text, whatever order the filters were ticked in.
  keyOf: (entry) => {
    const filters = parseFilterString(entry.filter);
    const normalized = Object.keys(filters).sort().map((key) => [
      key,
      key === 'year' ? filters[key] : filters[key].map(String).sort(),
    ]);
    return JSON.stringify(normalized) + '|' + (entry.search || '').trim().toLowerCase();
  },

  // What a search picks, in reading order: FD3S, MAZDA, RX-7, 1992–2002, Grade 4, ...
  describe: (entry) => {
    const filters = parseFilterString(entry.filter);
    const parts = [];
    const text = (entry.search || '').trim();
    if (text) parts.push(text);
    const makers = (filters.maker_name || []).filter((maker) => !COMPANION_MAKERS.includes(maker));
    if (makers.length) parts.push(makers.join(', '));
    const models = (filters.model || []).filter(
      (model) => !(String(model).endsWith('カイ') && filters.model.includes(String(model).replace('カイ', '')))
    );
    if (models.length) parts.push(models.map(toHalfWidth).join(', '));
    if (filters.year?.length === 2) parts.push(`${filters.year[0]}–${filters.year[1]}`);
    if (filters.grade?.length) parts.push(`Grade ${filters.grade.join(', ')}`);
    if (filters.transmission?.length) parts.push(filters.transmission.join(', '));
    if (filters.color?.length) parts.push([...new Set(filters.color.map(getColorGroup))].join(', '));
    if (filters.bidDate?.length) parts.push(`Bids ${filters.bidDate.join(', ')}`);
    return parts;
  },
};
